import LocalesProvider from './LocalesProvider.container';

export default LocalesProvider;
